import { FC, ReactNode } from 'react'
import { Text } from './Text'

interface Props {
  children?: ReactNode
  label: ReactNode
}

export const DescriptionItem: FC<Props> = ({ label, children }) => (
  <>
    <dt>
      <Text type="label">{label}</Text>
    </dt>
    <dd className="mt-1 text-sm text-gray-700">{children}</dd>
  </>
)
